import { Box, Typography, Link, IconButton } from '@mui/material';
import React from 'react';
import FileIcon from '@mui/icons-material/InsertDriveFile';
import DeleteIcon from '@mui/icons-material/Close';

interface Document {
	id: number;
	fileUrl: string;
	name: string;
}

interface Props {
    document: Document;
    onDelete?: () => void;
}

export const FileItem = ({document, onDelete}: Props) => {
	return <Box display="flex" flexDirection="row" gap={1} alignItems="center" key={document.id} sx={{backgroundColor: 'background.paper', p: 1, borderRadius: 1}}>
		<FileIcon color='success' />
		<Typography variant="body1" component="div">
			<Link href={document.fileUrl} target="_blank" rel="noopener noreferrer" sx={{color: 'primary'}}>{document.name}</Link>
		</Typography>
		{onDelete && <IconButton onClick={onDelete}>
			<DeleteIcon color='error' />
		</IconButton>}
	</Box>;
};